import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import 'document-register-element/build/document-register-element'

import * as VeeValidate from 'vee-validate';

import {
  ValidationProvider,
  ValidationObserver,
  localize,
} from 'vee-validate/dist/vee-validate.full';

import Portuguese from 'vee-validate/dist/locale/pt_BR.json'

// components validator
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

localize('pt_BR', Portuguese)


Vue.use(VeeValidate, {
  locale: 'pt_BR',
  inject: true,
  fieldsBagName: '$veeFields',
  errorBagName: '$veeErrors',
})


import router from './router'

require('./scss/main.scss')

import vueCustomElement from 'vue-custom-element'

Vue.use(vueCustomElement)

App.router = router

Vue.customElement ('vue-widget', App)


